import { payorSchema } from '@billing/validation/payor';
import type { z } from 'zod';

export type Payor = z.infer<typeof payorSchema>;

export enum PayorEnum {
  msh = 'MSH',
  qdoc = 'QDOC',
  mb = 'MB',
  wcb = 'WCB',
  private = 'Private',
  patient = 'Patient',
  blueCross = 'Blue Cross',
  bc = 'BC',
}

export enum PayorType {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
  DIRECT = 'DIRECT',
}

export type FormPayor = Omit<Payor, 'id'>;

export const isPayor = (obj: any): obj is Payor => {
  return payorSchema.safeParse(obj).success;
};
